<template>
  <div id="app">
    <language-switcher />
    <router-view :key="$i18n.locale" />
  </div>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

export default {
  name: 'App',
  components: {
    LanguageSwitcher
  }
};
</script>

<style lang="css" src="./assets/common.css"></style>
